export default __webpack_public_path__ + "static/media/Group 33.948b1137.png";